export enum AlertDialogTypeEnum {
    Warning,
    Confirm,
    Information
}


// WEBPACK FOOTER //
// ./src/app/_enums/alert_dialog_type.enum.ts